import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CardDialog from '@/components/dialogs/CardDialog.vue'
import useServiceStore from '@/store/service'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'NoBankAccountErrorDialog'
},
  __name: 'NoBankAccountErrorDialog',
  emits: ["cancel", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit



const router = useRouter()
const { t } = useI18n()
const serviceStore = useServiceStore()
const { isKyy } = storeToRefs(serviceStore)

const navigateToAccounts = async (): Promise<void> => {
  const route = isKyy.value ? 'bank_account_details' : 'bank_accounts'
  await router.push({ name: route })
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardDialog, {
    title: _unref(t)('error.no_bank_account'),
    onAction: navigateToAccounts,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
  }, {
    action: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('bank_account.error.set_bank_account')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(t)('bank_account.error.no_bank_account_desc')), 1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})